module.exports = __webpack_public_path__ + "static/media/img_sanexpedito.895c9ad7.jpg";